const STORAGE_TOKEN = "token";
const STORAGE_REFRESH_TOKEN = "refresh_token";
const DESKTOP_SMALL_WIDTH = 1468;
const TABLET_MAX_WIDTH = 1024;
const TABLET_MIN_WIDTH = 768;
const PAGE_SIZE = 500;
const PAGE_SIZE_LITTLE = 20;

enum USER_STATUS {
  ACTIVE = 1,
  INACTIVE = 2,
  LOCK = 3,
}

enum ORDER_STATUS {
  "New order" = 1,
  Pending = 2,
  "In progress" = 3,
  Delivered = 4,
  Cancel = 5,
}

const REGEX_URL =
  "(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})";
const REGEX_IMAGE = /(https?:\/\/.*\.(?:png|jpg|jpeg|gif|png|svg))$/;
const REGEX_PHONE_NUMBER = /^[0-9]{8,14}$/;
const PASSWORD_REGEX = /^[\w+]{1,15}$/;

const IMAGE_DEFAULT =
  "data:image/png;base64,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";

const PERMISSIONS = {
  ALL: "all",
  // User
  USER_CREATE: "user:create",
  USER_READ: "user:read",
  USER_EDIT: "user:update",
  USER_DELETE: "user:delete",
  USER_EXPORT: "user:export",
  USER_RESTORE: "user:restore",
  // Role
  ROLE_CREATE: "role:create",
  ROLE_READ: "role:read",
  ROLE_EDIT: "role:update",
  ROLE_DELETE: "role:delete",
  // Permission
  PERMISSION_READ: "permission:read",
  // Organization
  ORGANIZATION_CREATE: "organization:create",
  ORGANIZATION_READ: "organization:read",
  ORGANIZATION_EDIT: "organization:update",
  ORGANIZATION_DELETE: "organization:delete",
  // Company
  COMPANY_CREATE: "company:create",
  COMPANY_READ: "company:read",
  COMPANY_SEARCH: "company:search",
  COMPANY_EDIT: "company:update",
  COMPANY_DELETE: "company:delete",
  COMPANY_EXPORT: "company:export",
  COMPANY_RESTORE: "company:restore",
  // Warehouse
  WAREHOUSE_CREATE: "warehouse:create",
  WAREHOUSE_READ: "warehouse:read",
  WAREHOUSE_EDIT: "warehouse:update",
  WAREHOUSE_DELETE: "warehouse:delete",
  WAREHOUSE_EXPORT: "warehouse:export",
  // Bin
  BIN_CREATE: "bin:create",
  BIN_READ: "bin:read",
  BIN_EDIT: "bin:update",
  BIN_DELETE: "bin:delete",
  BIN_EXPORT: "bin:export",
  // Product
  PRODUCT_CREATE: "product:create",
  PRODUCT_READ: "product:read",
  PRODUCT_EDIT: "product:update",
  PRODUCT_DELETE: "product:delete",
  PRODUCT_EXPORT: "product:export",
  PRODUCT_IMPORT: "product:import",
  // Order
  ORDER_CREATE: "order:create",
  ORDER_READ: "order:read",
  ORDER_EDIT: "order:update",
  ORDER_DELETE: "order:delete",
  ORDER_EXPORT: "order:export",
  // Quick Order
  QUICK_ORDER_CREATE: "quick_order:create",
  QUICK_ORDER_READ: "quick_order:read",
  // Master Product
  MASTER_PRODUCT_CREATE: "master_product:create",
  MASTER_PRODUCT_READ: "master_product:read",
  MASTER_PRODUCT_EDIT: "master_product:update",
  MASTER_PRODUCT_DELETE: "master_product:delete",
  MASTER_PRODUCT_EXPORT: "master_product:export",
  MASTER_PRODUCT_IMPORT: "master_product:import",
};

const PERMISSIONS_DETAIL = [
  // {
  //   title: "All",
  //   type: 'all'
  // },
  {
    title: "USER",
    type: "USER",
    permission: [
      {
        title: "Create User",
        type: "create",
      },
      {
        title: "View User",
        type: "read",
      },
      {
        title: "Edit User",
        type: "update",
      },
      {
        title: "Delete User",
        type: "delete",
      },
      {
        title: "Restore User",
        type: "restore",
      },
      {
        title: "Export User",
        type: "export",
      },
    ],
  },
  {
    title: "ROLE",
    type: "ROLE",
    permission: [
      {
        title: "Create Role",
        type: "create",
      },
      {
        title: "View Role",
        type: "read",
      },
      {
        title: "Edit Role",
        type: "update",
      },
      {
        title: "Delete Role",
        type: "delete",
      },
    ],
  },
  {
    title: "MASTER PRODUCT",
    type: "MASTER_PRODUCT",
    permission: [
      {
        title: "Create Master Product",
        type: "create",
      },
      {
        title: "View Master Product",
        type: "read",
      },
      {
        title: "Edit Master Product",
        type: "update",
      },
      {
        title: "Delete Master Product",
        type: "delete",
      },
      {
        title: "Import Master Product",
        type: "import",
      },
      {
        title: "Export Master Product",
        type: "export",
      },
    ],
  },
  {
    title: "PRODUCT",
    type: "PRODUCT",
    permission: [
      {
        title: "Create Product",
        type: "create",
      },
      {
        title: "View Product",
        type: "read",
      },
      {
        title: "Edit Product",
        type: "update",
      },
      {
        title: "Delete Product",
        type: "delete",
      },
      {
        title: "Import Product",
        type: "import",
      },
      {
        title: "Export Product",
        type: "export",
      },
    ],
  },
  {
    title: "QUICK ORDER",
    type: "QUICK_ORDER",
    permission: [
      {
        title: "Create Quick Order",
        type: "create",
      },
      {
        title: "View Quick Order",
        type: "read",
      },
    ],
  },
  {
    title: "ORDER",
    type: "ORDER",
    permission: [
      {
        title: "Create Order",
        type: "create",
      },
      {
        title: "View Order",
        type: "read",
      },
      {
        title: "Edit Order",
        type: "update",
      },
      {
        title: "Delete Order",
        type: "delete",
      },
      {
        title: "Export Order",
        type: "export",
      },
    ],
  },
  {
    title: "WAREHOUSE",
    type: "WAREHOUSE",
    permission: [
      {
        title: "Create Warehouse",
        type: "create",
      },
      {
        title: "View Warehouse",
        type: "read",
      },
      {
        title: "Edit Warehouse",
        type: "update",
      },
      {
        title: "Delete Warehouse",
        type: "delete",
      },
      {
        title: "Export Warehouse",
        type: "export",
      },
    ],
  },
  {
    title: "BIN",
    type: "BIN",
    permission: [
      {
        title: "Create Bin",
        type: "create",
      },
      {
        title: "View Bin",
        type: "read",
      },
      {
        title: "Edit Bin",
        type: "update",
      },
      {
        title: "Delete Bin",
        type: "delete",
      },
      // {
      //   title: "Import Bin",
      //   type: "import",
      // },
    ],
  },
  {
    title: "COMPANY",
    type: "COMPANY",
    permission: [
      {
        title: "Create Company",
        type: "create",
      },
      {
        title: "View Company",
        type: "read",
      },
      {
        title: "Search Company",
        type: "search",
      },
      {
        title: "Edit Company",
        type: "update",
      },
      {
        title: "Delete Company",
        type: "delete",
      },
      {
        title: "Export Company",
        type: "export",
      },
      {
        title: "Restore Company",
        type: "restore",
      },
    ],
  },
   {
    title: "ORGANIZATION",
    type: "ORGANIZATION",
    permission: [
      {
        title: "Create Organization",
        type: "create",
      },
      {
        title: "View Organization",
        type: "read",
      },
      {
        title: "Edit Organization",
        type: "update",
      },
      {
        title: "Delete Organization",
        type: "delete",
      },
    ],
  },
];

const C = {
  STORAGE_TOKEN,
  STORAGE_REFRESH_TOKEN,
  TABLET_MAX_WIDTH,
  DESKTOP_SMALL_WIDTH,
  TABLET_MIN_WIDTH,
  PAGE_SIZE,
  PAGE_SIZE_LITTLE,
  USER_STATUS,
  ORDER_STATUS,
  REGEX_URL,
  REGEX_PHONE_NUMBER,
  REGEX_IMAGE,
  IMAGE_DEFAULT,
  PASSWORD_REGEX,
  PERMISSIONS,
  PERMISSIONS_DETAIL,
};

export default C;
